import { LabelableMixin } from "@evo/evonum";
export default LabelableMixin;
